import React from 'react';
import { Bold, Italic, Underline } from 'lucide-react';
import { wrapNotificationSelection } from '../PrestationPlanning/PrestationNotificationsPage';

/**
 * Barre de mise en forme d'un message d'email.
 *
 * Les marqueurs sont ceux que le serveur interprète déjà (`templateBodyToHtml`) : `**gras**`, `*italique*`,
 * `__souligné__`, `[[taille=Npx]]…[[/taille]]`. Aucun nouveau format à supporter à l'envoi, et le rendu est
 * exactement celui de tous les autres emails de l'application.
 *
 * Extraite ici parce qu'elle existait déjà à l'identique dans les réglages de notification (Prestation),
 * ceux de l'administration et les emails convives. En écrire une quatrième copie aurait garanti qu'elles
 * finissent par diverger. Les trois existantes n'ont pas été migrées — ce serait toucher trois écrans en
 * production pour un gain de forme ; à faire quand l'un d'eux sera de toute façon rouvert.
 */
const TAILLES = [
    { value: '12', label: 'Petit' },
    { value: '16', label: 'Normal' },
    { value: '20', label: 'Grand' },
    { value: '28', label: 'Très grand' },
];

export function MessageFormatBar({ textareaRef, value, onChange }: {
    textareaRef: React.RefObject<HTMLTextAreaElement | null>;
    value: string;
    onChange: (v: string) => void;
}) {
    const btn = 'p-1.5 rounded-md border border-border bg-surface-soft text-content-muted hover:text-content';
    return (
        <div className="flex items-center gap-1 flex-wrap">
            <button type="button" title="Gras" className={btn}
                onClick={() => wrapNotificationSelection(textareaRef.current, value, onChange, '**')}><Bold size={12} /></button>
            <button type="button" title="Italique" className={btn}
                onClick={() => wrapNotificationSelection(textareaRef.current, value, onChange, '*')}><Italic size={12} /></button>
            <button type="button" title="Souligné" className={btn}
                onClick={() => wrapNotificationSelection(textareaRef.current, value, onChange, '__')}><Underline size={12} /></button>
            <select defaultValue="" title="Taille du texte sélectionné"
                onChange={(e) => { if (e.target.value) { wrapNotificationSelection(textareaRef.current, value, onChange, `[[taille=${e.target.value}px]]`, '[[/taille]]'); e.target.value = ''; } }}
                className="p-1.5 rounded-md border border-border bg-surface-soft text-content-muted hover:text-content text-[11px] outline-none">
                <option value="" disabled>Taille</option>
                {TAILLES.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
            <span className="text-[10px] text-content-muted ml-1">Sélectionne du texte puis clique.</span>
        </div>
    );
}
